<mat-card appearance="outlined" class="color-picker-card">
  <mat-card-content>
    <div class="color-picker">
      <!-- TODO: add close button -->
      <!-- <app-close-button
        [hasChanges]="false"
        [backgroundColor]="'var(--mat-sys-secondary-container)'"
        (closed)="store.closeColorPicker()"
        class="color-picker__close-btn"
      >
      </app-close-button> -->

      <mat-icon
        class="color-picker__icon"
        [style.color]="
          previousColor() ? previousColor()?.color : selectedColor()?.color
        "
        [style.backgroundColor]="
          previousColor()
            ? previousColor()?.background
            : selectedColor()?.background
        "
        >{{ icon() }}</mat-icon
      >
      <div class="color-picker__options">
        @for (color of ColorOptions; track color) {
        <div
          role="button"
          tabindex="0"
          (click)="selectColor(color)"
          (keydown.enter)="selectColor(color)"
          [style.color]="color.color"
          [style.backgroundColor]="color.background"
          [style.borderColor]="
            isColorSelected(color) ? color.color : 'transparent'
          "
          [class.selected]="isColorSelected(color)"
          class="color-picker__option"
        ></div>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>
